let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kM1cW")).then(() => parcelRequire('2ws0G'));